import React from 'react';
import {connect} from "react-redux";
import PropTypes from 'prop-types';
import moment from 'moment';

import UserFieldElement from '../../../reusable/UserFieldElement';
import UserFieldDataType from "../../../../utils/enums/UserFieldDataTypeEnum";

import * as RaceActions from "../../../../actions/race";
import {NotificationManager} from "react-notifications";
import {fullfillTime, getRegi} from "../../../../../../common/src/util/lib";
import {calcMpm} from "../../../../../../common/src/util/raceUtil";
import {nullDate} from "../../../../../../common/src/common";
import UserRoles from "../../../../../../common/src/enums/UserRoles";

class RaceArrival extends React.Component {

    static propTypes = {
        race: PropTypes.object,
        setEditMode: PropTypes.func.isRequired,
    };

    constructor(props) {
        super(props);
        this.state = {
            club: props.auth.currentRole === UserRoles.CLUB_ADMIN.id ? props.auth.currentEntity : '',
            pigeonhole: '',
            editIx: null,
        };
    }

    componentDidMount() {
        if (this.props.auth.currentRole === UserRoles.CLUB_ADMIN.id) this.props.dispatch(RaceActions.getRacePigeons(this.props.race.Nr, this.props.auth.currentEntity));
    }

    fields = [];
    render() {
        return <div className={"form-page race-arrival " + (this.state.editIx !== null ? "editable" : "read-only")}>
            <div className="top-panel">
                <div className="top-content">
                    <div className="block-content">
                        <table>
                            <tbody>
                                <tr>
                                    <td><label className={this.state.editIx !== null || this.props.auth.currentRole === UserRoles.CLUB_ADMIN.id ? 'disabled' : ''} htmlFor="club">Forening</label></td>
                                    <td>
                                        <UserFieldElement dataType={UserFieldDataType.enum} placeholder={'-- Vælg --'} className="field100p" containerClassName="display-inline-block field100p" disabled={this.state.editIx !== null || this.props.auth.currentRole === UserRoles.CLUB_ADMIN.id}
                                                          name="club" id="club" value={this.state.club} options={
                                                              this.props.admin.clubs.filter(c =>
                                                                  (this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id && c.Sektionsnr !== '99') ||
                                                                  (this.props.auth.currentRole === UserRoles.SECTION_ADMIN.id && c.Sektionsnr === this.props.auth.currentEntity) ||
                                                                  (this.props.auth.currentRole === UserRoles.CLUB_ADMIN.id && c.Foreningsnr === this.props.auth.currentEntity)
                                                              ).sort((c1, c2) => c1.Foreningsnr < c2.Foreningsnr ? -1 : (c1.Foreningsnr > c2.Foreningsnr ? 1 : 0)).map(club => (
                                                                  {key: club.Foreningsnr, value: club.Foreningsnr + (club.Navn === null ? '' : ' - ' + club.Navn)}
                                                              )).toArray()
                                                          }
                                                          autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                          onChange={e => {
                                                              this.setState({club: e.target.value, pigeonhole: ''});
                                                              this.props.dispatch(RaceActions.getRacePigeons(this.props.race.Nr, e.target.value));
                                                          }}
                                                          ref={instance => { this.fields[0] = instance; }}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td><label className={this.state.club === '' || this.state.editIx !== null ? 'disabled' : ''} htmlFor="pigeonhole" disabled={this.state.club === ''}>Slag</label></td>
                                    <td>
                                        <UserFieldElement dataType={UserFieldDataType.enum} placeholder={'-- Vælg --'} className="field100p" containerClassName="display-inline-block field100p" disabled={this.state.club === '' || this.state.editIx !== null}
                                                          name="pigeonhole" id="pigeonhole" value={this.state.pigeonhole} options={
                                                              this.props.racePigeons.has(this.props.race.Nr + '/' + this.state.club) ?
                                                              this.props.racePigeons.get(this.props.race.Nr + '/' + this.state.club).pigeonholes.sort((s1, s2) => s1.Slagnr < s2.Slagnr ? -1 : (s1.Slagnr > s2.Slagnr ? 1 : 0)).map(pigeonhole => (
                                                                  {key: pigeonhole.Slagnr, value: pigeonhole.Slagnr + (pigeonhole.Slagnavn === null ? '' : ' - ' + pigeonhole.Slagnavn)}
                                                              )).toArray() : []
                                                          }
                                                          autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                          onChange={e => {
                                                              this.setState({pigeonhole: e.target.value});
                                                          }}
                                                          ref={instance => { this.fields[1] = instance; }}
                                        />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div className="bottom-panel">
                <div id="data-table" className="bottom-content">
                    <div className="block-content">
                        <table className="data-table">
                            <thead>
                                <tr>
                                    <th scope="row">Ringnummer</th>
                                    <th className="center">Sportsdue</th>
                                    <th>Hjemkomst</th>
                                    <th className="center">Døgn</th>
                                    <th className="center">Urnr.</th>
                                    <th>Meter / min.</th>
                                    <th>Korrigeret hjemkomst</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.club === '' || this.state.pigeonhole === '' ? [] : this.props.racePigeons.get(this.props.race.Nr + '/' + this.state.club).pigeonholes.get(this.state.pigeonhole).pigeons.sort((p1, p2) => p1.Ringnummer < p2.Ringnummer ? -1 : (p1.Ringnummer > p2.Ringnummer ? 1 : 0)).toArray().map((pigeon, ix, rows) => <tr key={pigeon.Ringnummer} id={'row-' + pigeon.Ringnummer}>
                                    <th scope="row">{pigeon.Ringnummer}</th>
                                    <td className="center">{pigeon.Sportsdue === null || pigeon.Sportsdue === 0 ? '' : 'X'}</td>
                                    <td>{this.state.editIx === ix ? <UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field100" containerClassName="display-inline-block"
                                                                               name="Hjemkomst" id="Hjemkomst" maxLength="8" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "([0-1][0-9]|20|21|22|23)\:[0-5][0-9]\:[0-5][0-9]"}]} value={this.state.Hjemkomst}
                                                                               autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                                               onChange={this.onStandardFieldChange}
                                                                               onBlur={(e) => {
                                                                                   this.fields[2].setState({focused: false, visited: true});
                                                                                   const value = fullfillTime(this.state.Hjemkomst, true);
                                                                                   if (value !== 'error') this.setState({Hjemkomst: value}, () => this.calcSpeed());
                                                                               }}
                                                                               ref={instance => { this.fields[2] = instance; }}
                                    /> : (pigeon.Hjemkomst === null ? null : moment.utc(pigeon.Hjemkomst).tz("Europe/Copenhagen").format('HH:mm:ss'))}</td>
                                    <td className="center">{this.state.editIx === ix ? <UserFieldElement dataType={UserFieldDataType.int} placeholder="" className="field50" containerClassName="display-inline-block"
                                                                               name="Doegn" id="Doegn" value={this.state.Doegn}
                                                                               autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                                               onChange={this.onStandardFieldChange}
                                                                               onBlur={(e) => {
                                                                                   this.fields[3].setState({focused: false, visited: true}, () => this.calcSpeed());
                                                                               }}
                                                                               ref={instance => { this.fields[3] = instance; }}
                                    /> : pigeon.Doegn}</td>
                                    <td className="center">{this.state.editIx === ix ? <UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field50" containerClassName="display-inline-block"
                                                                               name="Urnr" id="Urnr" maxLength="1" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[1-3]"}]} value={this.state.Urnr}
                                                                               autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                                               onChange={this.onStandardFieldChange}
                                                                               onBlur={(e) => {
                                                                                   this.fields[4].setState({focused: false, visited: true}, () => this.calcSpeed());
                                                                               }}
                                                                               ref={instance => { this.fields[4] = instance; }}
                                    /> : pigeon.Urnr}</td>
                                    <td>{this.state.editIx === ix ? (this.state.MeterPrMin === null ? null : this.state.MeterPrMin.toFixed(2).replace('.', ',')) : (pigeon.MeterPrMin === null ? null : pigeon.MeterPrMin.toFixed(2).replace('.', ','))}</td>
                                    <td>{this.state.editIx === ix ? (this.state.KorrigeretHjemkomst === null ? null : this.state.KorrigeretHjemkomst) : (pigeon.KorrigeretHjemkomst === null ? null : moment.utc(pigeon.KorrigeretHjemkomst).tz("Europe/Copenhagen").format('HH:mm:ss'))}</td>
                                    <td>{
                                        this.state.editIx === ix || (this.state.editIx === 'new' && ix === rows.length - 1) ? [
                                            <i key={0} className="fa fa-save clickable" title="Gem kapflyvningsdeltager"
                                               onClick={this.save}/>,
                                            <i key={1} className="fa fa-undo clickable" title="Annuller"
                                               onClick={this.cancelEdit}/>
                                        ] : [
                                            <i key={0}
                                               className={"fa fa-pencil " + (this.state.editIx === null && (this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id || this.props.auth.currentRole === UserRoles.CLUB_ADMIN.id || (this.props.auth.currentRole === UserRoles.SECTION_ADMIN.id && getRegi(this.props.race.Farvekode) === 'Sektion')) ? 'clickable' : 'disabled')}
                                               title="Rediger række" onClick={() => {
                                                if (this.state.editIx === null && (this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id || this.props.auth.currentRole === UserRoles.CLUB_ADMIN.id || (this.props.auth.currentRole === UserRoles.SECTION_ADMIN.id && getRegi(this.props.race.Farvekode) === 'Sektion'))) {
                                                    this.setState({
                                                        oldRingnummer: pigeon.Ringnummer === null ? '' : pigeon.Ringnummer,
                                                        Hjemkomst: pigeon.Hjemkomst === null ? '' : moment.utc(pigeon.Hjemkomst).tz("Europe/Copenhagen").format('HH:mm:ss'),
                                                        Doegn: pigeon.Doegn === null ? '' : String(pigeon.Doegn),
                                                        Urnr: pigeon.Urnr === null ? '' : String(pigeon.Urnr),
                                                        MeterPrMin: pigeon.MeterPrMin,
                                                        KorrigeretHjemkomst: pigeon.KorrigeretHjemkomst === null ? '' : moment.utc(pigeon.KorrigeretHjemkomst).tz("Europe/Copenhagen").format('HH:mm:ss'),
                                                        editIx: ix,
                                                    });
                                                    this.props.setEditMode(true);
                                                }
                                            }}/>,
                                        ]
                                    }</td>
                                </tr>)}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    }

    calcSpeed = () => {
        const pigeonhole = this.props.racePigeons.get(this.props.race.Nr + '/' + this.state.club).pigeonholes.get(this.state.pigeonhole);
        const club = this.props.admin.clubs.get(this.state.club);
        const race = this.props.races.get(this.props.race.Nr);
        const releaseIx = club && race && race.Slip ? race.Slip.findIndex(release => release.Sektionsnr === club.Sektionsnr) : -1;
        const watch = pigeonhole ? pigeonhole.watches.get(Number(this.state.Urnr)) : null;
        const speed = calcMpm(
            pigeonhole ? pigeonhole.Afstand : null,
            releaseIx >= 0 && race.Slip[releaseIx].Slipdato !== null ? new Date(race.Slip[releaseIx].Slipdato) : (race && race.SlipDato !== null ? new Date(race.SlipDato) : null),
            releaseIx >= 0 && race.Slip[releaseIx].Sliptid !== null ? race.Slip[releaseIx].Sliptid : (race ? race.Sliptid : null),
            this.state.Doegn === '' ? null : Number(this.state.Doegn),
            /^([0-1][0-9]|20|21|22|23):[0-5][0-9]:[0-5][0-9]$/.test(this.state.Hjemkomst) ? new Date(nullDate.year, nullDate.month - 1, nullDate.day, Number(this.state.Hjemkomst.substr(0, 2)), Number(this.state.Hjemkomst.substr(3, 2)), Number(this.state.Hjemkomst.substr(6, 2))) : null,
            pigeonhole ? this.props.racePigeons.get(this.props.race.Nr + '/' + this.state.club).night.Start : null,
            pigeonhole ? this.props.racePigeons.get(this.props.race.Nr + '/' + this.state.club).night.Slut : null,
            watch && watch.Startdato !== null ? new Date(watch.Startdato) : null, watch ? watch.Starttid : null,
            watch && watch.Kontroldato !== null ? new Date(watch.Kontroldato) : null, watch ? watch.Kontroltid : null,
            watch ? watch.FejlgangPrSek : null
        );
        this.setState({
            MeterPrMin: speed.mpm,
            KorrigeretHjemkomst: speed.correctedHomeTime,
        });
    };

    onStandardFieldChange = (e) => {
        const stateVariable = e.target.name;
        this.setState({[stateVariable]: e.target.value});
    };

    allInputValid = () => {
        let result = true;
        this.fields.forEach((field, ix) => {
            if (field && !field.isValid()) result = false;
        });
        return result;
    };

    createNew = () => {
        this.setState({
            editIx: 'new'
        });
        this.props.setEditMode(true);
    };

    cancelEdit = () => {
        this.setState({editIx: null});
        this.props.setEditMode(false);
    };

    save = () => {
        if (this.allInputValid()) {
            const entity = {
                Hjemkomst: this.state.Hjemkomst === '' ? null : this.state.Hjemkomst,
                Doegn: this.state.Doegn === '' ? null : Number(this.state.Doegn),
                Urnr: this.state.Urnr === '' ? null : Number(this.state.Urnr),
            };
            if (this.props.auth.currentRole === UserRoles.CLUB_ADMIN.id) entity.ResManAendret = -1;
            this.props.dispatch(RaceActions.updateRacePigeon(this.props.race.Nr, this.state.club, this.state.pigeonhole, this.state.oldRingnummer, entity, () => {
                NotificationManager.success("Ringnummer " + this.state.Ringnummer + " er opdateret.", "Opdatering", 4000);
                this.setState({editIx: null});
                this.props.setEditMode(false);
            }));
        } else {
            this.fields.forEach((field) => {
                field.setState({visited: true});
            });
        }
    }
}

const mapStateToProps = (state) => ({
    auth: {
        currentRole: state.auth.currentRole,
        currentEntity: state.auth.currentEntity,
    },
    admin: {
        clubs: state.admin.clubs,
    },
    races: state.race.races,
    racePigeons: state.race.racePigeons,
});

export default connect(mapStateToProps, null, null, {withRef: true})(RaceArrival);


// WEBPACK FOOTER //
// ./src/client/src/components/pages/race/subPages/RaceArrival.js